'use strict';
/**
 * Define used classes
 * @type {String}
 */
const articleClass = 'promocional col-lg-6 col-md-6 col-sm-6 hidden-xs';
const sectionWrapperClass = 'bg-blur col-form col-lg-6 col-md-6 col-sm-6';
const sectionClass = 'container registro';
const waitingGiftClass = 'full-width padding-2';
const waitingContainer = 'waiting-container';
/**
 * Import dependencies
 */
import React from 'react';
import { cleaner } from '../../helpers/cleaner';
import { connect } from 'react-redux';
import api, { updateDefaults } from 'services/api/microfwk';
import apiSticky, { updateDefaultsSticky } from 'services/api/microfwkSticky';
import { converter } from '../../helpers/converter';
import { GetRegion } from '../../constants';
import CheckboxClaro from '../forms/CheckboxClaro';
import SecurityFooter from '../footer/security_service/SecurityFooter';
import Request from '../../utils/request';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import RequestManager from '../../requests/RequestManager';
import termsTask from '../../requests/tasks/termsTask';
import * as modalActions from '../../actions/response';
import { execSafePushSession } from 'utils/getStickySession';
import _ from 'lodash';
import { setHKS } from '../../utils/HKS';
/**
 * Manage payment data and show it
 */
export class Terms extends React.Component {
  constructor() {
    super();
    this.state = {
      accept: false,
      error: '',
      waiting: true,
    };
    this.buttonAccept = '';
    this.buttonAbort = '';
  }
  /**
   * acceptTerms read accept terms
   */
  acceptTerms() {
    this.setState({ accept: !this.state.accept, error: '' });
  }
  abortButton() {
    window.location =
      window.location.origin + '/' + GetRegion() + '/user/logout';
  }

  obtenerDatosUsuario() {
    let logged_user = localStorage.getItem('loginInfo.logged_user_data');
    try {
      logged_user = JSON.parse(logged_user);
      return logged_user !== null && logged_user !== undefined
        ? logged_user
        : {};
    } catch (e) {
      console.log(e);
      return null;
    }
  }
  /**
   * saveTerms on API
   */
  saveTerms() {
    if (!this.state.accept) {
      return this.setState({
        error: cleaner.cleanInput(
          converter.convertApaUnicode(
            this.props.translations,
            'resgisto_error_terminosycondiciones',
          ),
        ),
      });
    }

    this.setState({ waiting: false });
    const userData = this.props.user;
    let customEndPoint = window.localStorage.getItem('customEndPoint');
    window.localStorage.removeItem('customEndPoint');
    if (customEndPoint) {
      try {
        customEndPoint = atob(customEndPoint);
      } catch (e) {
        customEndPoint = customEndPoint;
      }
      customEndPoint = customEndPoint.replace('http:', 'https:');
    }

    const termsOptions = {
      user_id: userData.user_id,
      user_hash: userData.userhash,
      terminos: 1,
      customEndPoint,
    };
    const terms = new termsTask(termsOptions);
    RequestManager.addRequest(terms)
      .then(result => {
        try {
          const userId = _.get(
            result,
            ['response', 'userData', 'user_id'],
            false,
          );
          const hks = _.get(
            result,
            ['response', 'userData', 'session_stringvalue'],
            null,
          );
          if (hks) {
            setHKS(hks);
            updateDefaults(api, { params: { HKS: hks } });
            updateDefaultsSticky(apiSticky, { params: { HKS: hks } });
          }
          if (userId)
            execSafePushSession(_.get(result, ['response', 'userData'], {}));
        } catch (err) {
          console.error('push session', err);
        } finally {
          localStorage.setItem('loginInfo.acceptedTerms', 1);
          const logged_user = this.obtenerDatosUsuario();
          this.setState({ waiting: false });
          const redireccion =
            Object.keys(logged_user).length > 0
              ? logged_user.hasSavedPayway
                ? '/homeuser'
                : '/payment'
              : '/user.php?login';

          window.location.href = '/' + GetRegion() + redireccion;
        }
      })
      .catch(err => {
        this.setState({ waiting: false });
        const message =
          err.message ||
          converter.convertApaUnicode(
            this.props.translations,
            'bad_response_error_msg',
          );

        const modal = {
          modalType: 'ErrorSimple',
          props: {
            message,
          },
        };
        this.props.showModal(modal);
      });
  }

  render() {
    this.buttonAccept = converter.convertApaUnicode(
      this.props.translations,
      'registro_aceptar',
    );
    this.buttonAbort = converter.convertApaUnicode(
      this.props.translations,
      'registro_cancelar',
    );
    let classWaiting = classNames({
      'full-width': true,
      'padding-2': true,
      hide: this.state.waiting,
    });
    /**
     * If translations is not already return an empity view
     */
    if (!this.props.translations.terms_content) {
      return (
        <section className={sectionClass}>
          <div className={waitingContainer}>
            <span id="cargando" className={waitingGiftClass}>
              <img
                className="center-block"
                src="/webclient/sk_core/images/cargando.gif"
                width="54"
              />
            </span>
          </div>
        </section>
      );
    }
    
    return (
      <section className={sectionClass}>
        <article className={articleClass}>
          <header
            className="oferta"
            dangerouslySetInnerHTML={{
              __html: cleaner.cleanInput(
                converter.convertApaUnicode(
                  this.props.translations,
                  'registro_paso2_text_image',
                ),
              ),
            }}
          />
        </article>
        <div className={sectionWrapperClass}>
          <div className="form-container">
            <h3>
              {converter.convertApaUnicode(
                this.props.translations,
                'iptelmex_title_userdetect_register_success',
                'Bienvenido a Clarovideo',
              )}
            </h3>
            <p>{this.props.translations.terms_content}</p>
            <div className="col-lg-12">
              <form>
                <CheckboxClaro
                  idElement="accepterms"
                  labelTip={converter.convertApaUnicode(
                    this.props.translations,
                    'resgisto_error_terminosycondiciones',
                  )}
                  value={0}
                  terminos1={converter.convertApaUnicode(
                    this.props.translations,
                    'registro_terminos_condiciones1',
                  )}
                  terminos2={converter.convertApaUnicode(
                    this.props.translations,
                    'registro_terminos_condiciones2',
                  )}
                  terminos3={converter.convertApaUnicode(
                    this.props.translations,
                    'registro_terminos_condiciones3',
                  )}
                  onChange={this.acceptTerms.bind(this)}
                  error={this.state.error}
                  terminosLink={this.props.translations.terms_content_btn}
                />
              </form>
              <div className="row padding-top-2">
                <div className="col-lg-4 col-md-4">
                  <span className={classWaiting}>
                    <img
                      className="center-block"
                      src="/webclient/sk_core/images/cargando.gif"
                      width="54"
                    />
                  </span>
                </div>

                <div
                  className="col-lg-4 col-md-4"
                  onClick={this.abortButton.bind(this)}
                >
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-default btn-lg btn-block"
                    >
                      {this.buttonAbort}
                    </button>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4">
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg btn-block"
                      onClick={this.saveTerms.bind(this)}
                    >
                      {this.buttonAccept}
                    </button>
                  </div>
                </div>
              </div>
              <SecurityFooter
                translations={this.props.translations}
                config={this.props.config}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  metadata: state.metadata,
  translations: state.translations,
  router: state.routing,
  user: state.user,
  config: state.config,
});

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(modalActions.showModal(modal));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Terms);
